import { BuchungsheldLitElement } from '@adornis/buchungsheld-components/BuchungsheldLitElement.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import '../registration/bh-page-registration.js';

@customElement('bh-page-debug')
export class BHPageDebug extends BuchungsheldLitElement {
  override render() {
    return html`
      <x-flex space="sm" padding="lg">
        <bh-page-registration
          mode="embed"
          step="workshop"
          institution="6459fbb7baf42b555f7b6645"
        ></bh-page-registration>
      </x-flex>
    `;
  }

  override styles() {
    return [...super.styles(), {}];
  }
}
